import { cn } from '@/libs/tailwind';

type SignUpFormWrapperProps = {
  children: React.ReactNode;
  title?: string;
  header?: React.ReactNode;
  className?: string;
};

export const SignUpFormWrapper: React.FC<SignUpFormWrapperProps> = ({ className, children, title, header }) => {
  return (
    <>
      <div
        className={cn('flex min-w-[400px] max-w-[400px] min-h-[380px] px-6 py-6 flex-col items-center gap-5 rounded-xl border border-fg-border bg-white shadow-[0px_0px_12px_0px_rgba(0,0,0,0.04)] relative', className)}
      >
        {header}
        {!header && (
          <h2 className="text-center text-header-md">
            {title}
          </h2>
        )}
        <div className="w-full h-full flex justify-center items-center flex-col gap-6">
          {children}
        </div>
      </div>
    </>
  );
};
